import * as Yup from 'yup';

export const editTagsFormValidation = () => {
  return Yup.object().shape({
    tags: Yup.array()
      .test(
        'all-strings',
        'All elements in tags must be strings',
        (value) => value == null || value.every((v) => typeof v === 'string'),
      )
      .nullable(),
  });
};

export default editTagsFormValidation;
